import React from 'react';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { SystemOverview } from './components/SystemOverview';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { SystemBlueprint } from './components/SystemBlueprint';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { MoreTestimonials } from './components/MoreTestimonials';
import { Guarantee } from './components/Guarantee';
import { Steps } from './components/Steps';
import { FinalCTA } from './components/FinalCTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-full w-full overflow-x-hidden bg-warm font-sans text-navy" data-id="element-0" data-mp="28te1n9vnj3li">
      <MetaPixel data-id="element-1" data-mp="23w4fc33k781w" />
      <OfferBar data-id="element-2" data-mp="23ujkecdc1n3i" />
      <div className="h-11" aria-hidden="true" data-id="element-3" data-mp="23v2rey1g2r2r" />
      <main data-id="element-4" data-mp="3ikh8gaq64uzi">
        <Hero data-id="element-5" data-mp="3ikqy1x7ax04o" />
        <SystemOverview data-id="element-6" data-mp="3ij64a9st9l7v" />
        <Testimonials data-id="element-7" data-mp="3ijpef4c7z5bc" />
        <PainPoints data-id="element-8" data-mp="3mlj8gtrwtb2j" />
        <SystemBlueprint data-id="element-9" data-mp="3ml1234bj9ggw" />
        <Bonuses data-id="element-10" data-mp="3mk85gw6ag7ch" />
        <Pricing data-id="element-11" data-mp="3mjq3diwy2ywn" />
        <MoreTestimonials data-id="element-12" data-mp="3mj6k9yvk64h1" />
        <Guarantee data-id="element-13" data-mp="3rbrayrj641gc" />
        <Steps data-id="element-14" data-mp="3rdar8i4tqci4" />
        <FinalCTA data-id="element-15" data-mp="3rcsw5otwe4bs" />
        <FAQ data-id="element-16" data-mp="3recdlirailf5" />
      </main>
      <Footer data-id="element-17" data-mp="5ott78p769p" />
    </div>;
}